import {Controller} from 'react-hook-form'
import {InputLabel, styled} from '@mui/material'
import {useI18n} from 'store/Store'
import Uploader from 'components/Control/Upload/ImageUploader'

const FormImageUploader = ({
    name,
    control,
    label,
    accept,
    onUpload,
    url,
    showImage = true,
}) => {
    const {i18n} = useI18n()

    return (
        <Controller
            name={name}
            control={control}
            render={({field: {onChange}}) => (
                <Container>
                    {label && <Label>{label}</Label>}
                    <Uploader
                        accept={accept}
                        onChange={onChange}
                        onUpload={onUpload}
                        url={url}
                        showImage={showImage}
                        label={label}
                        i18n={i18n}
                    />
                </Container>
            )}
        />
    )
}

export default FormImageUploader

const Container = styled('div')``

const Label = styled(InputLabel)`
    margin-bottom: 10px;
    font-size: 12px;
`
